import React from 'react';
import Route from 'react-router-dom/Route';
import Redirect from 'react-router-dom/Redirect';

function ProtectedRoute(props) {
  const { component: Component, ...rest } = props; // eslint-disable-line react/prop-types

  return (
    <Route
      {...rest}
      // eslint-disable-next-line no-shadow, no-confusing-arrow
      render={props => rest.user ? <Component {...props} /> : <Redirect to="/login" />}
    />
  );
}

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/containers/App/ProtectedRoute.js